
{
  "familyId": "REK-GEMENGD-BASIS",
  "questions": [
    {
      "id": "REK-GEMENGD-BASIS-001",
      "familyId": "REK-GEMENGD-BASIS",
      "module": "Basisrekenen",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "gemengd",
      "subSkill": "gemengd_bewerkingen",
      "questionType": "multiple_choice",
      "question": "Welke bewerking gebruik je? Een bakker bakt 8 broden per uur. Hij werkt 6 uur. Hoeveel broden bakt hij?",
      "options": ["8 × 6 = 48", "8 + 6 = 14", "8 − 6 = 2", "8 ÷ 6 = 1,3..."],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Welke bewerking? — Herhaald optellen = keer",
            "content": "8 broden per uur, 6 uur lang. Dat is 8 + 8 + 8 + 8 + 8 + 8 = herhaald optellen. Herhaald optellen = vermenigvuldigen: 8 × 6 = 48. Signaalwoord: 'per' wijst vaak op vermenigvuldigen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "gemengd_bewerking_herkennen_keer",
      "variantIndex": 1,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "8 broden per uur, 6 uur lang = 8 × 6 = 48 broden. Het signaalwoord 'per' wijst op vermenigvuldigen: een vast aantal dat zich herhaalt.",
        "solutionSteps": [
          "Lees: 8 broden per uur, 6 uur",
          "Herken signaalwoord 'per' → vermenigvuldigen",
          "Bewerking: 8 × 6 = 48 broden"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Per uur' wijst op vermenigvuldigen: 8 × 6 = 48 broden.",
          "1": "Optellen (8 + 6 = 14) klopt niet. De bakker bakt niet 8 broden EN 6 broden, maar 8 broden PER uur gedurende 6 uur. Dat is vermenigvuldigen.",
          "2": "Aftrekken (8 − 6 = 2) klopt niet. Er gaat niets af — de bakker bakt broden, hij verliest ze niet.",
          "3": "Delen (8 ÷ 6) klopt niet. Je deelt niet 8 broden over 6 uur — je bakt 8 broden IN elk uur. Dat is vermenigvuldigen."
        }
      }
    },
    {
      "id": "REK-GEMENGD-BASIS-002",
      "familyId": "REK-GEMENGD-BASIS",
      "module": "Basisrekenen",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "gemengd",
      "subSkill": "gemengd_bewerkingen",
      "questionType": "fill_in",
      "question": "Reken uit: 156 + 87 − 43",
      "options": [],
      "correctAnswer": "200",
      "data": {
        "acceptedAnswers": ["200"]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Van links naar rechts",
            "content": "Bij optellen en aftrekken reken je van links naar rechts. Eerst: 156 + 87 = 243. Dan: 243 − 43 = 200. Tip: 243 − 43 is makkelijk — de tientallen en eenheden zijn gelijk!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "gemengd_plus_min_combinatie",
      "variantIndex": 2,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "Van links naar rechts: 156 + 87 = 243, dan 243 − 43 = 200. Tip: als de eenheden en tientallen gelijk zijn (243 − 43), is het aftrekken extra makkelijk!",
        "solutionSteps": [
          "Stap 1: 156 + 87 = 243",
          "Stap 2: 243 − 43 = 200"
        ]
      }
    },
    {
      "id": "REK-GEMENGD-BASIS-003",
      "familyId": "REK-GEMENGD-BASIS",
      "module": "Basisrekenen",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "gemengd",
      "subSkill": "gemengd_bewerkingen",
      "questionType": "multiple_choice",
      "question": "Welke bewerking gebruik je? 96 leerlingen worden verdeeld over 8 gelijke groepen. Hoeveel leerlingen zitten er in elke groep?",
      "options": ["96 ÷ 8 = 12", "96 − 8 = 88", "96 × 8 = 768", "96 + 8 = 104"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verdelen = delen",
            "content": "96 leerlingen verdelen over 8 groepen = 96 ÷ 8. Signaalwoord: 'verdelen over' wijst op delen. 96 ÷ 8 = 12 leerlingen per groep.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "gemengd_bewerking_herkennen_delen",
      "variantIndex": 3,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "'Verdelen over gelijke groepen' = delen. 96 ÷ 8 = 12 leerlingen per groep. Signaalwoorden voor delen: 'verdelen', 'per', 'hoeveel in elke', 'eerlijk verdelen'.",
        "solutionSteps": [
          "Herken signaalwoord: 'verdelen over' → delen",
          "Bewerking: 96 ÷ 8",
          "Antwoord: 96 ÷ 8 = 12 leerlingen"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Verdelen over' = delen: 96 ÷ 8 = 12 leerlingen per groep.",
          "1": "Aftrekken (96 − 8 = 88) klopt niet. Je haalt niet 8 leerlingen weg — je verdeelt ze in groepen.",
          "2": "Vermenigvuldigen (96 × 8 = 768) klopt niet. Je hebt 96 leerlingen, niet 96 groepen van 8.",
          "3": "Optellen (96 + 8 = 104) klopt niet. Er komen geen leerlingen bij — je verdeelt de bestaande 96."
        }
      }
    },
    {
      "id": "REK-GEMENGD-BASIS-004",
      "familyId": "REK-GEMENGD-BASIS",
      "module": "Basisrekenen",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "gemengd",
      "subSkill": "gemengd_bewerkingen",
      "questionType": "fill_in",
      "question": "Reken uit: 7 × 9 + 37",
      "options": [],
      "correctAnswer": "100",
      "data": {
        "acceptedAnswers": ["100"]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Volgorde: × en ÷ gaan vóór + en −",
            "content": "Bij gemengde bewerkingen reken je eerst × en ÷, dan + en −. Eerst: 7 × 9 = 63. Dan: 63 + 37 = 100. Je mag NIET eerst 9 + 37 = 46 doen en dan 7 × 46 = 322!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "gemengd_volgorde_keer_plus",
      "variantIndex": 4,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Volgorde: × gaat vóór +. Eerst 7 × 9 = 63, dan 63 + 37 = 100. Onthoud: Meneer Van Dansen Wacht Op Antwoord — × en ÷ komen vóór + en −.",
        "solutionSteps": [
          "Volgorde: × gaat vóór +",
          "Eerst: 7 × 9 = 63",
          "Dan: 63 + 37 = 100"
        ]
      }
    },
    {
      "id": "REK-GEMENGD-BASIS-005",
      "familyId": "REK-GEMENGD-BASIS",
      "module": "Basisrekenen",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "gemengd",
      "subSkill": "gemengd_bewerkingen",
      "questionType": "multiple_choice",
      "question": "Een winkelier heeft 5 dozen met elk 24 flessen sap. Ze verkoopt 38 flessen. Hoeveel flessen heeft ze nog?",
      "options": ["82 flessen", "120 flessen", "158 flessen", "62 flessen"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Twee bewerkingen: eerst ×, dan −",
            "content": "Stap 1: Hoeveel flessen in totaal? 5 × 24 = 120. Stap 2: Hoeveel over na verkoop? 120 − 38 = 82. Tip: herken de twee bewerkingen — 'dozen met elk' = ×, 'verkoopt' = −.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "gemengd_context_keer_min",
      "variantIndex": 5,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Totaal: 5 × 24 = 120 flessen. Verkocht: 120 − 38 = 82 flessen over. Twee bewerkingen: 'dozen met elk' = vermenigvuldigen, 'verkoopt' = aftrekken.",
        "solutionSteps": [
          "Stap 1: 5 dozen × 24 flessen = 120 flessen",
          "Stap 2: 120 − 38 verkocht = 82 flessen over"
        ],
        "distractorExplanations": {
          "0": "Goed! 5 × 24 = 120, dan 120 − 38 = 82 flessen over.",
          "1": "Je berekende het totaal (5 × 24 = 120) maar vergat de 38 verkochte flessen af te trekken. 120 − 38 = 82.",
          "2": "Je dacht waarschijnlijk 5 × 24 = 120, dan 120 + 38 = 158. Maar flessen worden VERKOCHT — dat is aftrekken, niet optellen.",
          "3": "Je dacht waarschijnlijk 5 × 24 = 120, dan 120 − 58 = 62. Maar er zijn 38 flessen verkocht, niet 58. 120 − 38 = 82."
        }
      }
    }
  ]
}
